import Input from '../input/input';
import React, { useEffect, useRef } from 'react';
import { AddressFinder } from "@ideal-postcodes/address-finder";
import { classnames } from '../../../utils/classnames';

export default function AddressFinderSelect({ name, value, onAddressChange, onChange, label, purePlaceholder, error, rules, className, disabled = false }) {
  const shouldRender = useRef(true);

  useEffect(() => {
    if (!shouldRender.current) return;
    shouldRender.current = false;

    AddressFinder.setup({
      inputField: "#id-address",
      apiKey: process.env.ADDRESS_FINDER_KEY,
      detectCountry: false,
      defaultCountry: "GBR",
      restrictCountries: ["GBR"],
      onAddressRetrieved: (address) => {
        const fullAddress = [
          address.line_1,
          address.line_2,
          address.line_3,
          address.post_town,
          address.postcode
          ]
          .filter((elem) => elem !== "")
          .join(", ");

          onAddressChange(address, fullAddress, address.postcode);
      },
    });
  }, []);

  return (
    <Input
      className={classnames("address-select-input", className ? className : '')}
      name={name}
      value={value}
      onChange={onChange}
      label={label}
      disabled={disabled}
      purePlaceholder={purePlaceholder}
      error={error}
      rules={rules}
    />
  )
}